<template>
	<div class="c-faq__accordion--item">
		<button @click="onToggle" :aria-controls="elementId" :aria-expanded="isOpen ? 'true' : 'false'">
			<span>{{ item.question }}</span>
			<span>
				<v-icon name="icon-plus" v-show="!isOpen" />
				<v-icon name="icon-minus" v-show="isOpen" />
			</span>
		</button>
		<article v-show="isOpen" :id="elementId">
			<div class="c-faq-accordion--answer" v-html="item.answer"></div>

			<div class="c-faq-accordion--youtube" v-if="item.youTubeLink">
				<you-tube-player :url="item.youTubeLink" :title="item.linkText"></you-tube-player>
			</div>

			<div class="c-faq__accordion--articlelink" v-if="item.link">
				<a :href="item.link">
					<span>{{ item.linkText }}</span>
					<span>
						<v-icon name="icon-chevron" />
					</span>
				</a>
			</div>
		</article>
	</div>
</template>

<script>
import VIcon from '../icon/VIcon.vue';
import YouTubePlayer from "../you-tube-player/YouTubePlayer.vue";
export default {
	name: "VFaqAccordionItem",
	components: { VIcon, YouTubePlayer },
	props: {
		item: {
			type: Object,
			default: () => { }
		},
		category: {
			type: String,
			default: ''
		},
		isDefaultQuestion: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isOpen: false
		}
	},
	computed: {
		elementId: function () {
			return `faq-accordion-item-${this.item.id}`;
		}
	},

	methods: {
		onToggle() {
			this.isOpen = !this.isOpen;

			if (this.isOpen) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'view_faq',
					'question': this.item.question,
					'category': this.category
				});
			}
		}
	},
	mounted() {
		if (this.isDefaultQuestion) {
			document.getElementById(this.elementId).scrollIntoView({ behavior: 'smooth' });
			this.onToggle();
		}
	}
};
</script>
